import * as React from 'react'
import { FormattedHTMLMessage, FormattedMessage } from 'react-intl'

import DoodleBackground from '../../../../components/doodle-background'
import { Column, Row } from '../../../../components/layout-row'
import Textblock from '../../../../components/textblock'

import styles from './departments.module.scss'

const TypeOfJob = ({ jobs }: { jobs: string | React.ReactElement }) => (
  <span className={styles.departmentJobs}>
    <FormattedMessage
      defaultMessage="Typ av jobb: {jobs}"
      id="career.departments.type-of-jobs"
      values={{
        jobs,
      }}
    />
  </span>
)

const Departments = () => (
  <div className={styles.root} id="departments">
    <h2 className={styles.title}>
      <FormattedHTMLMessage
        defaultMessage="När du blir en Dooer kommer&nbsp;du&nbsp;få supersmarta kollegor&nbsp;med&nbsp;massor av olika unika spetskompetenser."
        id="career.departments.title"
      />
    </h2>

    <Row alignItems="start" className={styles.margin}>
      <Column first limitWidth>
        <Textblock
          description={
            <FormattedMessage
              defaultMessage="På Dooer utvecklar vi allt här i Sverige. Som utvecklare får du chansen att bygga teknik i världsklass med en modern standardiserad teknikstack i absoluta framkant."
              id="career.departments.dev-description"
            />
          }
          extra={
            <TypeOfJob
              jobs={
                <FormattedHTMLMessage
                  defaultMessage="Frontend, Backend, Fullstack, UX<span class='visible-xs'>, IT-arkitektur</span>"
                  id="career.departments.dev-jobs"
                />
              }
            />
          }
          title={
            <>
              <span className={styles.titleCircle} />
              <FormattedMessage defaultMessage="Utveckling" id="career.departments.dev-title" />
            </>
          }
        />
      </Column>
      <Column limitWidth>
        <Textblock
          description={
            <FormattedMessage
              defaultMessage="Vi bygger ett av de starkaste varumärkena inom bokföringsbranschen. Hos&nbsp;oss får du vara med och förändra en hel bransch med smart och effektiv kommunikation."
              id="career.departments.market-description"
            />
          }
          extra={
            <TypeOfJob
              jobs={
                <FormattedHTMLMessage
                  defaultMessage="SEO, SEM, Copy, AD, Designer<span class='visible-xs'>, Fotograf, Analytiker</span>"
                  id="career.departments.market-jobs"
                />
              }
            />
          }
          title={
            <>
              <span className={styles.titleCircle} />
              <FormattedMessage defaultMessage="Marknad" id="career.departments.market-title" />
            </>
          }
        />
      </Column>
    </Row>

    <Row alignItems="start" className={styles.margin}>
      <Column first limitWidth>
        <Textblock
          description={
            <FormattedMessage
              defaultMessage="Här skapas framtidens Dooer. Vi utvecklar både nya tjänster, arbetssätt och mjukvaror för att det ska vara så smidigt som möjligt för våra kunder att&nbsp;driva företag."
              id="career.departments.bus-dev-description"
            />
          }
          extra={
            <TypeOfJob
              jobs={
                <FormattedHTMLMessage
                  defaultMessage="Compliance<span class='visible-xs'>, Produktutvecklare</span>"
                  id="career.departments.bus-dev-jobs"
                />
              }
            />
          }
          title={
            <>
              <span className={styles.titleCircle} />
              <FormattedMessage defaultMessage="Affärsutveckling" id="career.departments.bus-dev-title" />
            </>
          }
        />
      </Column>
      <Column limitWidth>
        <Textblock
          description={
            <FormattedMessage
              defaultMessage="Vi växer snabbt. På våra interna stödfunktioner gör du det möjligt för oss att hålla hög hastighet samtidigt som förutsättningarna för hela teamet är de absolut bästa."
              id="career.departments.bus-support-description"
            />
          }
          extra={
            <TypeOfJob
              jobs={
                <FormattedHTMLMessage
                  defaultMessage="HR-generalist, Rekryterare<span class='visible-xs'>, Kontorsansvarig, Support</span>"
                  id="career.departments.bus-support-jobs"
                />
              }
            />
          }
          title={
            <>
              <span className={styles.titleCircle} />
              <FormattedMessage defaultMessage="Affärsstöd" id="career.departments.bus-support-title" />
            </>
          }
        />
      </Column>
    </Row>

    <DoodleBackground variant="topLeft" />
  </div>
)

export default Departments
